const safeRun = (fun: () => string | null | void): string | null | void => {
  try {
    return fun();
  } catch (error) {}
  return null;
};

export default {
  getItem: (key: string) => safeRun(() => window.sessionStorage.getItem(key)),
  setItem: (key: string, value: string) =>
    safeRun(() => window.sessionStorage.setItem(key, value)),
};
